enum PhotoType {
  ALL = 'all',
  MATCHING = 'matching',
  FAILED = 'failed',
}

export default PhotoType;
